import { FLWinningPerson } from '../model/fl-winning.model';
import { SortDirection } from '../model/sort-direction.model';

export function sortByFLWinning(
    sortDirection: SortDirection = SortDirection.ASC,
) {
    // sortDirection: true = asc score, desc totalopps, asc name;
    //                false = desc score, asc totalopps, desc name
    return (a: FLWinningPerson, b: FLWinningPerson) => {
        let retVal = 0;

        retVal = byFLWinning(a, b, sortDirection);
        if (retVal !== null) {
            return retVal;
        }

        if (retVal !== null) {
            return retVal;
        }

        return 0;
    };
}
const byFLWinning = (
    a: FLWinningPerson,
    b: FLWinningPerson,
    sortDirection: SortDirection,
): number => {
    const s1 = a.FLWinningPercentage;
    const s2 = b.FLWinningPercentage;

    let retVal: number | null = null;
    if (s1 === undefined) return -1;
    if (s2 === undefined) return -1;
    if (s1 == null && s2 != null) return 1;
    else if (s2 == null && s1 != null) return -1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }
    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};
